<template>
  <div>
    <validation-observer ref="fatorRiscoForm">
      <b-form @ubmit.prevent>
        <b-row>
          <b-col cols="12">
            <b-form-textarea
              v-model="recomendacoes.recomendacoes"
              :disabled="disableForm"
              rows="3"
              max-rows="6"
            />
          </b-col>
        </b-row>
        <b-row>
          <ButtonsFormVue
            label-edit="Editar Recomendações"
            label-save="Salvar Recomendações"
            :disable-form="disableForm"
            :loading-button="loading"
            :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
            :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
            @save="salvar"
            @edit="editar"
            @cancel="beforeCancelar"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import {
  BButton,
  BFormGroup,
  BFormCheckbox,
  BFormTextarea,
  BModal,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
import mixinsGlobal from "@/mixins";
export default {
  props: {
    parecer: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixinsGlobal],
  components: {
    AppCollapseItem,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    ButtonsFormVue,
  },
  data() {
    return {
      loading: false,
      disableForm: true,
      recomendacoes: {},
    };
  },
  watch: {
    parecer: {
      handler(newVal) {
        this.setRecomendacaoData(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    beforeCancelar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Deseja realmente sair da atualização do Fator de Risco?",
          {
            title: "Confirmação",
            size: "sm",
            okVariant: "primary",
            okTitle: "Sim",
            cancelTitle: "Não",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelar();
          }
        });
    },
    cancelar() {
      this.disableForm = true;
      this.loadingCampos = false;
      this.setRecomendacaoData(this.parecer);
      this.$refs.fatorRiscoForm.reset();
      this.$emit("disable-form-changed", this.disableForm);
    },
    setRecomendacaoData(data) {
      if (data) {
        this.recomendacoes.id = data.id;
        this.recomendacoes.recomendacoes = data.recomendacoes;
      }
    },
    async editar() {
      this.disableForm = false;
      this.$emit("disable-form-changed", this.disableForm);
    },
    salvar(isAutoSave = false) {
      this.$refs.fatorRiscoForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          try {
            this.$store
              .dispatch(
                "parecerCardiologicoModule/salvarRecomendacao",
                this.recomendacoes
              )
              .then((response) => {
                this.recomendacoes.id = response.data.id;
                this.recomendacoes.recomendacoes = response.data.recomendacoes;
                this.disableForm = true;
                this.showMessageSuccess(
                  "Editar",
                  "Recomendação Editada com sucesso!"
                );
                this.$emit("disable-form-changed", this.disableForm);
              });
          } catch (error) {
            this.MensagemError("Salvar", "Falha ao salvar!");
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>
